<div class="market-data-display">
  <!-- spot -->
  <div
    *ngIf="marketDataExpanded && isRowEnabled('spot')"
    class="results-row center-text"
  >
    <ng-container *ngIf="pricedLeg.marketData?.length">
      {{ pricedLeg.marketData[0].spot?.bid | strikeFormatter: cross }}
      {{ pricedLeg.marketData[0].spot?.bid !== null ? '/' : null }}
      {{ pricedLeg.marketData[0].spot?.ask | strikeFormatter: cross }}
    </ng-container>
  </div>

  <!-- forward -->
  <div
    *ngIf="marketDataExpanded && isRowEnabled('forward')"
    class="results-row center-text"
  >
    <ng-container *ngIf="pricedLeg.marketData?.length">
      {{ pricedLeg.marketData[0].forward?.bid | strikeFormatter: cross }}
      {{ pricedLeg.marketData[0].forward?.bid !== null ? '/' : null }}
      {{ pricedLeg.marketData[0].forward?.ask | strikeFormatter: cross }}
    </ng-container>
  </div>

  <!-- forwardPoints -->
  <div
    *ngIf="marketDataExpanded && isRowEnabled('forwardPoints')"
    class="results-row center-text"
  >
    <ng-container *ngIf="pricedLeg.marketData?.length">
      {{
        pricedLeg.marketData[0].forwardPoints?.bid
          | forwardPointsFormatter
            : 'forwardPointsBid'
            : attributesAsFormControls
      }}
      {{ pricedLeg.marketData[0].forwardPoints?.bid !== null ? '/' : null }}
      {{
        pricedLeg.marketData[0].forwardPoints?.ask
          | forwardPointsFormatter
            : 'forwardPointsAsk'
            : attributesAsFormControls
      }}
    </ng-container>
  </div>

  <!-- volAtm -->
  <div
    *ngIf="marketDataExpanded && isRowEnabled('volAtm')"
    class="results-row center-text"
  >
    <ng-container *ngIf="pricedLeg.marketData?.length">
      {{ pricedLeg.marketData[0].atmVol?.bid | percent: '1.2-2' }}
      {{ pricedLeg.marketData[0].atmVol?.bid !== null ? '/' : null }}
      {{ pricedLeg.marketData[0].atmVol?.ask | percent: '1.2-2' }}
    </ng-container>
  </div>

  <!-- vol -->
  <div
    *ngIf="marketDataExpanded && isRowEnabled('vol')"
    class="results-row center-text"
  >
    <ng-container *ngIf="pricedLeg.marketData?.length">
      {{ pricedLeg.marketData[0].strikeVol?.bid | percent: '1.2-2' }}
      {{ pricedLeg.marketData[0].strikeVol?.bid !== null ? '/' : null }}
      {{ pricedLeg.marketData[0].strikeVol?.ask | percent: '1.2-2' }}
    </ng-container>
  </div>
</div>
